import * as types from './types'

const data = {
	loading: false,
	success: false,
	failed: false,
	data: null,
}

const initialState = {
	data: data,
	calculator: data,

	cropDistricts: {
		region: data,
		rai: data,
	},
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.GET_DATA:
			return { ...state, data: { ...data, loading: true } }

		case types.GET_DATA_DONE:
			return { ...state, data: { ...data, data: payload, success: true } }

		case types.GET_DATA_FAIL:
			return { ...state, data: { ...data, failed: true } }


		case types.GET_CALCULATOR:
			return { ...state, calculator: { ...data, loading: true, data: {...state.calculator.data, [payload]: null} } }

		case types.GET_CALCULATOR_DONE:
			return { ...state, calculator: { ...data, data: {...state.calculator.data, ...payload}, success: true } }

		case types.GET_CALCULATOR_FAIL:
			return { ...state, calculator: { ...data, failed: true } }

		case types.GET_CALCULATOR_RESET:
			return { ...state, calculator: { ...data, data: {...state.calculator.data, [payload]: null} } }


		case types.GET_CROP_REGION:
			return { ...state, cropDistricts: {...initialState.cropDistricts, region: { ...data, loading: true} } }

		case types.GET_CROP_REGION_DONE:
			return { ...state, cropDistricts: {...initialState.cropDistricts, region: { ...data, data: payload, success: true } } }

		case types.GET_CROP_REGION_FAIL:
			return { ...state, cropDistricts: {...initialState.cropDistricts, region: { ...data, failed: true } } }

		case types.GET_CROP_RAI:
			return { ...state, cropDistricts: {...state.cropDistricts, rai: { ...data, loading: true} } }

		case types.GET_CROP_RAI_DONE:
			return { ...state, cropDistricts: {...state.cropDistricts, rai: { ...data, data: payload, success: true } } }

		case types.GET_CROP_RAI_FAIL:
			return { ...state, cropDistricts: {...state.cropDistricts, rai: { ...data, failed: true } } }


		default:
			return state
	}
}
